// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8-KDi","content":"styles_content__7R-S-"};